// extracted by mini-css-extract-plugin
export var limitWidthOnLargeScreens = "PageLayout-module--limitWidthOnLargeScreens--cPelU";
export var loadingEffect = "PageLayout-module--loadingEffect--cFYT4";
export var overflowXHidden = "PageLayout-module--overflowXHidden--DThgM";
export var pageLayout = "PageLayout-module--pageLayout--fDuZk";
export var skipLink = "PageLayout-module--skip-link--VW805";